// Build an .ics calendar file with one event + alarm per watering day.
const pad = (n) => String(n).padStart(2, "0");
const stamp = (d, hh, mm) => `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(hh)}${pad(mm)}00`;
const esc = (s) => String(s).replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");
const fmt = (v) => String(v).replace(".", ",");

export const buildIrrigationIcs = (weeks, time) => {
  const [hh, mm] = time.split(":").map(Number);
  const now = new Date();
  const dtstamp = `${now.getUTCFullYear()}${pad(now.getUTCMonth() + 1)}${pad(now.getUTCDate())}T${pad(now.getUTCHours())}${pad(now.getUTCMinutes())}00Z`;
  const events = weeks.flatMap(({ label, days }) => days.filter((d) => d.water).map(({ date, doses }) => {
    const end = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hh, mm + 15);
    const desc = [`${label} · dosis por litro de agua:`, ...doses.map((x) => `- ${x.name}: ${fmt(x.dose)} mL/L`)].join("\n");
    return [
      "BEGIN:VEVENT",
      `UID:riego-${stamp(date, hh, mm)}@junglenutrient`,
      `DTSTAMP:${dtstamp}`,
      `DTSTART:${stamp(date, hh, mm)}`,
      `DTEND:${stamp(end, end.getHours(), end.getMinutes())}`,
      `SUMMARY:${esc(`Riego Jungle · ${doses.map((x) => x.name).join(" + ") || "agua"}`)}`,
      `DESCRIPTION:${esc(desc)}`,
      "BEGIN:VALARM", "ACTION:DISPLAY", `DESCRIPTION:${esc("Hoy toca riego Jungle")}`, "TRIGGER:PT0M", "END:VALARM",
      "END:VEVENT",
    ].join("\r\n");
  }));
  return wrap(events, "Riegos Jungle", "Cuadrante de riego");
};

const wrap = (events, name, prod) => ["BEGIN:VCALENDAR", "VERSION:2.0", `PRODID:-//Jungle Nutrient//${prod}//ES`, "CALSCALE:GREGORIAN", "METHOD:PUBLISH",
  `X-WR-CALNAME:${name}`, ...events, "END:VCALENDAR"].join("\r\n");

const day = (d) => `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`;

// All-day events for the key dates of the grow plan, each with a 09:00 alert that day.
export const buildPlanIcs = (milestones, genetic) => {
  const now = new Date();
  const dtstamp = `${now.getUTCFullYear()}${pad(now.getUTCMonth() + 1)}${pad(now.getUTCDate())}T${pad(now.getUTCHours())}${pad(now.getUTCMinutes())}00Z`;
  const events = milestones.map(([title, d], i) => {
    const next = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
    return [
      "BEGIN:VEVENT",
      `UID:plan-${i}-${day(d)}@junglenutrient`,
      `DTSTAMP:${dtstamp}`,
      `DTSTART;VALUE=DATE:${day(d)}`,
      `DTEND;VALUE=DATE:${day(next)}`,
      `SUMMARY:${esc(`Jungle · ${title}`)}`,
      `DESCRIPTION:${esc(`Plan de cultivo Jungle (${genetic}): ${title}.`)}`,
      "BEGIN:VALARM", "ACTION:DISPLAY", `DESCRIPTION:${esc(`Jungle · ${title}`)}`, "TRIGGER:PT9H", "END:VALARM",
      "END:VEVENT",
    ].join("\r\n");
  });
  return wrap(events, "Mi cultivo Jungle", "Plan de cultivo");
};

export const downloadIcs = (content, name) => {
  const url = URL.createObjectURL(new Blob([content], { type: "text/calendar;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};
